import { initializeApp } from "firebase/app"
import {getAuth} from 'firebase/auth'
import { getFirestore } from "firebase/firestore";
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
const firebaseConfig = {
 apiKey: "AIzaSyAQ-8EIGswauBVzU2h1yoguTV7HvflitQ4",
  authDomain: "dft-capital.firebaseapp.com",
  projectId: "dft-capital",
  storageBucket: "dft-capital.firebasestorage.app",
  messagingSenderId: "669431624638",
  appId: "1:669431624638:web:1cca86919898aca73effef",
  measurementId: "G-6QCG33BM80"
};

const firebaseApp = initializeApp(firebaseConfig)
const auth = getAuth(firebaseApp)
const db = getFirestore(firebaseApp)
const functions = getFunctions(firebaseApp, 'us-central1');
const storage = getStorage(firebaseApp);

export { db, auth, functions, storage }